import brand, { ThemeOption } from '@helpers/brand';
import { siteWide } from '@helpers/grid';
import { Device, from } from '@helpers/media';
import styled from 'styled-components';
const Container = styled.section `
  --sectionSpacingTop: 40px;
  --sectionSpacingBottom: 40px;

  position: relative;
  scroll-margin: var(--headerHeight) 0 0;

  &[data-allow-scroll-margin='true'] {
    overflow: clip;
  }

  &[data-flush='top'] {
    --sectionSpacingTop: 0;

    @media ${from(Device.Tablet)} {
      --sectionSpacingTop: 0;
    }
  }

  &[data-flush='bottom'] {
    --sectionSpacingBottom: 0;

    @media ${from(Device.Tablet)} {
      --sectionSpacingBottom: 0;
    }
  }

  &[data-flush='both'] {
    --sectionSpacingTop: 0;
    --sectionSpacingBottom: 0;

    @media ${from(Device.Tablet)} {
      --sectionSpacingTop: 0;
      --sectionSpacingBottom: 0;
    }
  }

  &[data-component-theme=${ThemeOption.Orange}] {
    --themeColor: ${brand.orange};
  }

  &[data-component-theme=${ThemeOption.Blue}] {
    --themeColor: ${brand.blue};
  }

  &[data-component-theme=${ThemeOption.Purple}] {
    --themeColor: ${brand.purple};
  }

  &[data-component-theme=${ThemeOption.Red}] {
    --themeColor: ${brand.red};
  }

  &[data-component-theme=${ThemeOption.Green}] {
    --themeColor: ${brand.green.default};
  }

  &[data-component-theme=${ThemeOption.DarkGreen}] {
    --themeColor: ${brand.green.dark};
  }

  &[data-component-theme=${ThemeOption.Teal}] {
    --themeColor: ${brand.teal};
  }
`;
const Inner = styled.div `
  color: var(--fgColor);
  padding-top: var(--sectionSpacingTop);
  padding-bottom: var(--sectionSpacingBottom);
`;
export const SiteWide = styled.div `
  ${siteWide}

  [data-inner-width="reduced"] & {
    --siteWidth: 1136px;
  }

  [data-inner-width='narrow'] & {
    --siteWidth: 880px;
  }
`;
const SectionWrapperStyles = {
    Container,
    Inner,
    SiteWide,
};
export default SectionWrapperStyles;
